/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PaymentBreakdownQueryVariables = Types.Exact<{
  input: Types.GenerateTransactionPlanInput;
}>;

export type PaymentBreakdownQuery = {
  readonly __typename?: 'Query';
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly transactionPlan:
      | { readonly __typename: 'CustomerNotOnboardedError'; readonly errorMessage: string }
      | { readonly __typename: 'OrderMissingTotalError'; readonly errorMessage: string }
      | {
          readonly __typename: 'TransactionPlanResult';
          readonly transactionPlan: ReadonlyArray<{
            readonly __typename?: 'TransactionPlan';
            readonly amountInCents: number;
            readonly automaticCapture: boolean | null;
            readonly processor: string;
          }>;
        }
      | null;
  } | null;
};

export const PaymentBreakdownDocument = gql`
  query PaymentBreakdown($input: GenerateTransactionPlanInput!) {
    cart {
      id
      __typename
      transactionPlan(input: $input) {
        __typename
        ... on TransactionPlanResult {
          transactionPlan {
            amountInCents
            automaticCapture
            processor
          }
        }
        ... on CustomerNotOnboardedError {
          errorMessage
        }
        ... on OrderMissingTotalError {
          errorMessage
        }
      }
    }
  }
`;

export function usePaymentBreakdownQuery(
  options: Omit<Urql.UseQueryArgs<PaymentBreakdownQueryVariables>, 'query'>,
) {
  return Urql.useQuery<PaymentBreakdownQuery, PaymentBreakdownQueryVariables>({
    query: PaymentBreakdownDocument,
    ...options,
  });
}
